<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="indent">
          <strong>
            <a @click="showViewModal = true" v-if="item.description">
              {{name}}
            </a>
            <span v-else>{{name}}</span>
          </strong>
        </div>
      </div>
      <div class="col-flex" v-if="canEdit">
        <a :id="`${section}-${item._id}`" @click="showEditModal = true" class="cogs125 modal-toggle">
          <i class="fa fa-cog"></i>
        </a>
      </div>
    </div>

    <ez-modal v-if="showViewModal" @close="showViewModal = false" size="m-medium">
      <h3>{{item.name}}</h3>
      <display :item="item"></display>
    </ez-modal>

    <ez-modal v-if="showEditModal && canEdit" @close="showEditModal = false" size="m-medium">
      <h3>Note</h3>
      <default :section="section" :item="item" @close="showEditModal = false"></default>
      <clone-delete-item
        :section="section"
        :item="item"
        @close="showEditModal = false">
      </clone-delete-item>
    </ez-modal>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CloneDeleteItem from "../shared/_CloneDeleteItem.vue";
import Default from "./_Default.vue";
import Display from "./_Display.vue";
import modal from "@/mixins/vue-ez-modal";

export default {
  name: "sheet-notes-note",
  mixins: [modal],
  components: {
    CloneDeleteItem,
    Default,
    Display
  },
  props: ["section", "item"],
  data() {
    return {
      showViewModal: false,
      showEditModal: false
    };
  },
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" }),
    name() {
      return this.item.name || "Note";
    }
  }
};
</script>
